import React from 'react';
import SelectOption from '../../../../common/SelectOption';
import { SPACE_ACTIVITIES } from './../../../../common/constants';

const Activity = ({ category, handleActivityOnSelect, venueTypes, deselectItems, disabled }) => {
  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!'
    }
  ];
  if (category && category === 'Work') {
    return (
      <SelectOption
        isMultiple={false}
        name={'eventId'}
        placeholder={'Activity'}
        rules={rules}
        label={'Activity'}
        values={venueTypes}
        labelName={'name'}
        valueName={'id'}
        handleOnSelect={handleActivityOnSelect}
        disabled={disabled}
      />
    );
  } else if (category && (category === 'Meet' || category === 'Shoot')) {
    return (
      <SelectOption
        isMultiple={true}
        name={'eventId'}
        placeholder={'Activity'}
        rules={rules}
        label={'Activity'}
        values={venueTypes}
        labelName={'name'}
        valueName={'id'}
        handleOnSelect={handleActivityOnSelect}
        handleOnDeselect={deselectItems}
        disabled={disabled}
      />
    );
  } else {
    return <></>;
  }
};

export default Activity;
